<script type="text/jsx">
import UnSupportDeviceForPartner from '@/views/config/partner-refer/unsupport-device-partner';

export default {
  render() {
    // for partner referral in mobile device
    return <UnSupportDeviceForPartner />;
  },
};
</script>
